import { jsx as _jsx } from "react/jsx-runtime";
import { GameTimeFrame } from "@/store/api";
import { GameAction } from "@/views/game/gameAction/GameAction";
import GameDetailsPage from "@/views/game/gameDetails";
import GameEditPage from "@/views/game/gameEdit";
import GamesListPage from "@/views/game/gamesList";
import { RoutesList } from "../routesList";
// ВНИМАТЕЛЬНО!!!
// Структура пути для типа списка игр и id игры совпадает, поэтому порядок важен
// /games/upcoming ~ /games/personal ~ /games/gameId
/** Роуты для игр */
export var routesGame = [
    {
        path: RoutesList.Game.getGamesList(),
        element: _jsx(GamesListPage, {}),
    },
    {
        path: RoutesList.Game.getAllGamesList(),
        element: _jsx(GamesListPage, { timeFrame: GameTimeFrame.All }),
    },
    {
        path: RoutesList.Game.getPastGamesList(),
        element: _jsx(GamesListPage, { timeFrame: GameTimeFrame.Past }),
    },
    {
        path: RoutesList.Game.getPersonalGamesList(),
        element: _jsx(GamesListPage, { isPersonal: true }),
    },
    {
        path: RoutesList.Game.getPersonalAllGamesList(),
        element: _jsx(GamesListPage, { isPersonal: true, timeFrame: GameTimeFrame.All }),
    },
    {
        path: RoutesList.Game.getPersonalPastGamesList(),
        element: _jsx(GamesListPage, { isPersonal: true, timeFrame: GameTimeFrame.Past }),
    },
    {
        path: RoutesList.Game.getGameDetails(":gameId"),
        element: _jsx(GameDetailsPage, {}),
    },
    {
        path: RoutesList.Game.getGameEdit(":gameId"),
        element: _jsx(GameEditPage, {}),
    },
    {
        path: RoutesList.Game.getGameAcceptInvite(":gameId"),
        element: _jsx(GameAction, { action: "accept" }),
    },
];
